import PropTypes from 'prop-types'
import isEmpty from 'lodash/isEmpty'
import { Link } from 'react-router-dom'
import { Card, Col, Hidden, Visible } from '@leroy-merlin-br/backyard-react-ui'

import Glyph from 'reactGarden/Glyph'

import { formatDate } from 'reactUtils/date'
import { useResize } from 'reactUtils/hooks/use-resize'

import * as S from './styled'

const Professional = ({ data }) => {
  const [isMobile] = useResize()

  if (isEmpty(data.payload) || data.isRequest) {
    return null
  }

  const { id, professionalName, projectName, status, expireAt } = data.payload

  return (
    <Card title="Meu Profissional">
      <Link to={`/profissional/${id}`}>
        <S.ModuleContent>
          <S.Divider size={{ mega: 3 }}>
            <S.ModuleWrapper>
              <S.ModuleAvatar>
                {professionalName.substring(0, 1)}
              </S.ModuleAvatar>
              <S.TextWrapper>
                <S.Text bold noMargin>
                  {professionalName}
                </S.Text>
                <Visible untilKilo>
                  <S.Text noMargin>{projectName}</S.Text>
                </Visible>
                <S.Status size="kilo" noMargin>
                  {status}
                </S.Status>
              </S.TextWrapper>
            </S.ModuleWrapper>
          </S.Divider>

          <Hidden untilKilo>
            <Col size={{ mega: 2 }}>
              <S.ModuleWrapper>
                <S.TextWrapper>
                  <S.Text noMargin>Nome do projeto:</S.Text>
                  <S.Text colorSecondary noMargin>
                    {projectName}
                  </S.Text>
                </S.TextWrapper>
              </S.ModuleWrapper>
            </Col>
          </Hidden>

          <Hidden untilKilo>
            <Col size={{ mega: 3 }}>
              <S.ModuleWrapper>
                <S.TextWrapper>
                  <S.Text noMargin>Tempo Previsto:</S.Text>
                  {expireAt && (
                    <S.Text size="kilo" noMargin>
                      ({formatDate(expireAt, 'DD/MM/YYYY')})
                    </S.Text>
                  )}
                </S.TextWrapper>

                <S.ButtonIcon>
                  <Glyph glyph="arrow" direction="right" />
                </S.ButtonIcon>
              </S.ModuleWrapper>
            </Col>
          </Hidden>
        </S.ModuleContent>
      </Link>
    </Card>
  )
}

Professional.propTypes = {
  data: PropTypes.shape({
    payload: PropTypes.shape({
      id: PropTypes.string,
      professionalName: PropTypes.string,
      projectName: PropTypes.string,
      status: PropTypes.string,
      expireAt: PropTypes.string
    }),
    isRequest: PropTypes.bool
  })
}

export default Professional
